/**
 * Mirror of backend `SkillNormalizer.normalize()` for client-side de-dup.
 * Keep this in sync with `apps/backend/src/modules/recruitment/skill-normalizer.ts`.
 */
export function normalizeSkillName(input: string): string {
  return input.trim().replace(/\s+/g, ' ').toLowerCase();
}
